import { inject, Injectable } from '@angular/core';
import {
  InitService,
  Note,
  NotificationService,
  RestService,
} from '@infodata-group/inf-commons';
import { ApplicationFactory } from '../model/factory/application-factory';
import { Application } from '../model/application';
import { Subject } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root',
})
export class OpenAppService {
  private readonly rest = inject(RestService);
  private readonly init = inject(InitService);
  private readonly note = inject(NotificationService);
  private readonly deviceService = inject(DeviceDetectorService);

  public applications: Application[] = [];
  public isLoaded = false;
  public isLoaded$: Subject<boolean> = new Subject<boolean>();

  constructor() {
    this.init.subscribe((event) => {
      if (event.name === 'config') {
        this.loadApps();
      }
    });
  }

  public loadApps() {
    this.rest.getAll(new ApplicationFactory()).subscribe((applications) => {
      this.applications = applications;
      this.isLoaded = true;
      this.isLoaded$.next(true);
    });
  }

  public open(appId: string) {
    const url = 'api/openapp?app=' + appId;
    this.rest.httpClient.put<any>(url, null).subscribe((result) => {
      if (result && result.location) {
        document.location.href = this.deviceService.isDesktop()
          ? result.location
          : this.getMobileUrl(result.location);
      } else {
        const note = new Note(
          'appOpen.locationError.title',
          'exclamation-triangle',
          'appOpen.locationError.content',
          null,
          '(400) Malformed server response',
        );
        this.note.addNotification(note);
      }
    });
  }

  public getMobileUrl(originalUrl: string): string {
    try {
      const url = new URL(originalUrl);
      const segments = url.pathname.split('/').filter(Boolean);
      const oauthIndex = segments.indexOf('oauth2');
      if (oauthIndex !== -1) {
        segments.splice(oauthIndex, 0, 'mobile');
      } else {
        segments.unshift('mobile');
      }
      url.pathname = '/' + segments.join('/');
      return url.toString();
    } catch {
      return originalUrl;
    }
  }

  getApplication(appId: any) {
    return this.applications.find((app) => app.id === appId);
  }
}
